import Icon from 'veui/components/Icon'
import { IconSmiley } from 'dls-icons-vue'

Icon.register('smiley', IconSmiley)
